"use client"

import { useState, useMemo, useEffect, useCallback } from "react"
import debounce from "lodash.debounce"

const SearchBar = ({
  onSearch,
  placeholder = "Search",
  debounceDelay = 1000,
  disabled = false,
  className = "",
  searchIconUrl,
  style = {},
  value = "",
}) => {
  const [searchValue, setSearchValue] = useState(value)

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        if (onSearch) {
          onSearch(value)
        }
      }, debounceDelay),
    [onSearch, debounceDelay],
  )

  useEffect(() => {
    return () => {
      debouncedSearch.cancel()
    }
  }, [debouncedSearch])

  const handleSearchChange = useCallback(
    (e) => {
      const value = e.target.value
      setSearchValue(value)
      debouncedSearch(value)
    },
    [debouncedSearch],
  )
  return (
    <div className={`search-bar-section ${className}`} style={{   backgroundColor: "#F5F6FA",   width: "100%",   display: "flex",   alignItems: "center",  padding: "8px 12px",   borderRadius: "20px",   gap: "8px",   ...style, }}>
      {searchIconUrl && (
        <img src={searchIconUrl || "/placeholder.svg"} alt="Search Icon" style={{ width: "16px", height: "16px" }} />
      )}

      <input id="searchbar" type="text"  value={searchValue}  placeholder={placeholder}  onChange={(e)=>handleSearchChange(e)}  disabled={disabled}  style={{  color: "#6D4194",  backgroundColor: "transparent",  border: "none",   outline: "none",  flex: 1,  fontSize: "14px",}}/>
    </div>
  )
}

export default SearchBar